// Utilities
import { defineStore } from 'pinia'
import axios from 'axios'
import router from '@/router'
import { useRoute, useRouter } from 'vue-router'
import helpers from '@/functions/helpers'


export const useAppStore = defineStore('app', {
  state: () => ({
    _loading: false,
    _loadingTimeout: null,
    _statuses: {},
    _statusTimeouts: {},
    _dialogActive: false,
    _pageErrorStatus: {
      status: null,
      text: null,
      error: false
    },
    _updateUrls: false,
    _globalInfo: {},
    _subject: null,
    _statusBarMounted: false,
    _authToken: localStorage.getItem('token'),
    _adminName: localStorage.getItem('adminName'),
    _adminId: localStorage.getItem('adminId'),
    _emailIntercept: null,
    _routerKey: 0
  }),
  getters: {
    loading: state => state._loading,
    loadingTimeout: state => state._loadingTimeout,
    statuses: state => state._statuses,
    dialogActive: state => state._dialogActive,
    tokenInfo: state => state._tokenInfo,
    tokenId: state => state._tokenId,
    pageErrorStatus: state => state._pageErrorStatus,
    updateUrls: state => state._updateUrls,
    globalInfo: state => state._globalInfo,
    subject: state => state._subject,
    authToken: state => state._authToken,
    adminName: state => state._adminName,
    adminId: state => state._adminId,
    emailIntercept: state => state._emailIntercept,
    routerKey: state => state._routerKey
  },
  actions: {
    initToken() {
      const route = useRoute();
      const router = useRouter();

      // // Check if tokenId exists in the URL
      // const params = new URLSearchParams(window.location.search)
      // let tokenId = params.get('tokenId');

      // if (tokenId) {
      //   // If tokenId exists in URL, store it in localStorage
      //   localStorage.setItem('tokenId', tokenId);
      // } else {
      //   // Otherwise, get it from localStorage
      //   tokenId = localStorage.getItem('tokenId');
      // }

      // // Update the store state
      // if (tokenId) {
      //   this._tokenId = tokenId;
      // }
    },
    setSubject(subject) {
      this._subject = subject
    },
    startLoader() {
      clearTimeout(this._loadingTimeout)
      this._loadingTimeout = null
      this._loading = true
    },
    endLoader() {
      this._loadingTimeout = setTimeout(() => {
        this._loading = false
      }, 1000)
    },
    setGlobalInfo(key, value) {
      this._globalInfo[key] = value
    },
    setStatus(key, message, type, persist = false, noScroll = false, actionKey = null) {
      // If an actionKey is provided, clear any existing statuses with the same actionKey
      if (actionKey) {
        Object.keys(this._statuses).forEach((existingKey) => {
          const existingStatus = this._statuses[existingKey]
          if (existingStatus && existingStatus.actionKey === actionKey) {
            // Clear timeout if it exists
            if (this._statusTimeouts[existingKey]) {
              clearTimeout(this._statusTimeouts[existingKey])
              delete this._statusTimeouts[existingKey]
            }
            // Remove the status
            delete this._statuses[existingKey]
          }
        })
      }

      // Clear any existing timeout for this status key
      if (this._statusTimeouts[key]) {
        clearTimeout(this._statusTimeouts[key])
        delete this._statusTimeouts[key]
      }

      this._statuses[key] = {
        message: message.message
          ? message.message
          : message,
        type: type,
        ...(persist && { persist: true }),
        ...(actionKey && { actionKey: actionKey })
      }

      // No auto-dismiss - user must manually dismiss
      // No auto-scroll - don't scroll to top
    },
    setBulkStatus(namespace, data) {
      data.failed.forEach((x, index) => {
        this.setStatus(`${namespace}.failed${index}`, x, 'danger')
      })
      data.succeeded.forEach((x, index) => {
        this.setStatus(`${namespace}.succeeded${index}`, x, 'success')
      })
    },
    clearStatus(key, clearNamespace = false) {
      // Clear all statuses in namespace
      if (clearNamespace) {
        Object.keys(this._statuses).forEach((objKey, objValue) => {
          if (objKey.startsWith(key)) {
            // Clear timeout if it exists
            if (this._statusTimeouts[objKey]) {
              clearTimeout(this._statusTimeouts[objKey])
              delete this._statusTimeouts[objKey]
            }
            delete this._statuses[objKey]
          }
        })
      }

      // Otherwise, clear just this status
      else {
        // Clear timeout if it exists
        if (this._statusTimeouts[key]) {
          clearTimeout(this._statusTimeouts[key])
          delete this._statusTimeouts[key]
        }
        delete this._statuses[key]
      }
    },
    clearAllStatuses() {
      // Clear all timeouts
      Object.values(this._statusTimeouts).forEach(timeout => {
        clearTimeout(timeout)
      })
      this._statusTimeouts = {}
      this._statuses = {}
    },
    setDialogActive() {
      this._dialogActive = true
    },
    setDialogInactive() {
      this._dialogActive = false
    },
    trackIframeHeight() {
      this.sendIframeHeight()
      const observer = new MutationObserver(this.sendIframeHeight)
      observer.observe(document.body, { childList: true, subtree: true })
    },
    sendIframeHeight() {
      const mainHeight = document.getElementById('app')
        ? document.getElementById('app').offsetHeight
        : document.getElementById('page-error')
          ? document.getElementById('page-error').offsetHeight
          : false
      const height = document.documentElement.scrollHeight || document.body.scrollHeight
      let finalHeight = mainHeight || height
      // finalHeight += 20
      if (finalHeight < 400 || this._loading == true)
        finalHeight = 400
      setTimeout(function () {
        window.parent.postMessage({ iframeHeight: finalHeight }, '*')
      }, 100)
    },
    sendInstruction(key, value = null) {
      if (window.parent) {
        window.parent.postMessage({
          instruction: key,
          ...(value && {value: value })
        }, '*')
      }
    },
    async fetchIpAddress() {
      try {
        const response = await axios.get('https://api.ipify.org?format-json')
        return response.data
      } catch(e) {
        console.error('Error fetching IP address:', e)
        return 'Could not fetch'
      }
    },
    setTokenInfo(tokenInfo) {
      this._tokenInfo = tokenInfo
    },
    setPageError(status = null, statusText = null) {
      this._pageErrorStatus.status = status
      this._pageErrorStatus.text = statusText
      this._pageErrorStatus.error = true
    },
    getTokenInfoType() {
      return this._tokenInfo ? this._tokenInfo.type : null
    },
    navigateToProperRoute() {
      // const params = new URLSearchParams(window.location.search)
      // if (params.get('updateUrls') == 'yes') {
      //   const currRoute =  router.currentRoute.value.path
      //   const pathName = params.get('path')
      //   if (!pathName) {
      //   } else if (currRoute !== pathName) {
      //     router.push(pathName)
      //   }
      // }
    },
    processUpdateUrls() {
      // const pathString = router.currentRoute.value.path.replace(/^\/+/, '').replace(/\//g, '%2F')
      //   this.sendInstruction('updatePath', pathString)
    },
    setAuth(token, adminName, adminId) {
      localStorage.setItem('token', token)
      localStorage.setItem('adminName', adminName)
      localStorage.setItem('adminId', adminId)
      this._authToken = token
      this._adminName = adminName
      this._adminId = adminId
    },
    clearAuth() {
      localStorage.removeItem('token')
      this._authToken = null
      this._adminName = null
      this._adminId = null
    },
    logOut() {
      const token = this.authToken
      if (token) {
        this.clearAuth()
        router.push('/log-in')
      }
    },
    async checkForEmailIntercept() {
      try {
        const response = await axios.get(
          `options`
        )
        const options = helpers.transformToArray(response.data)
        const found = options.find(x => {
          return x.key == 'emailIntercept' && x.value !== ''
        })
        if (found) {
          this._emailIntercept = found.value
        }
      } catch {}
    },
    forceReload() {
      this._routerKey += 1
    },
    scrollToTop(element = window) {
      setTimeout(function () {
        element.scrollTo({top: 0, behavior: 'smooth'})
      }, 2)
    },
    setTarget(key, value) {
      const newQueryString = `${key}=${value}`
      const url = new URL(window.location.href)

      url.search = newQueryString.startsWith("?")
        ? newQueryString
        : "?" + newQueryString

      this.startLoader()

      // Hard reload
      window.location.href = url.toString()
    },
    async clearAllExpCollections(endLoader = false) {
      try {
        this.clearStatus('actions.clearAllExpCollections')
        this.startLoader()
        const response = await axios.post(
          `system/clear-all-exp-collections`
        )
        this.setStatus('actions.clearAllExpCollections', 'The exp. collections were cleared', 'success')
        this.endLoader()
        return { success: true }
      } catch(e) {
        this.endLoader()
        this.setStatus('actions.clearAllExpCollections', e.response.data, 'danger')
        return { success: false }
      }
    }
  }
})
